import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { makeStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Theme } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import Paper from '@mui/material/Paper';
import useNotification from '../../../../../components/_hook/useNotification';
import useRouter from '../../../../../components/_hook/useRouter';
import Chatroom from '../../../../../adminComponents/chatroom/Chatroom';
import MESSAGE from '../../../../../components/constant/message';
import useRoutes from '../../../../../components/_hook/useRoutes';
import { useChatroomQuery } from '../../../../../../graphql/query/chatroom/useChatroomQuery';
import Context from '../../../../../context';
import CircularProgress from '../../../../../components/_loading/CircularProgress';

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  paper: {
    margin: theme.spacing(1),
    padding: theme.spacing(3),
    width: '100%',
  },
  rootContainer: { marginTop: theme.spacing(2) },
}));

export default function DropshipedRequestForDropshipDetailDisabled() {
  const { t } = useTranslation();
  const classes = useStyles();
  const { notification } = useNotification();
  const { company: contextCompany, user: contextUser } = useContext(Context);
  const [isShowMessenger, setIsShowMessenger] = useState(false);
  const { params, history } = useRouter();
  const { path } = useRoutes();
  const { companyID, toCompanyID } = params;

  const { data, loading } = useChatroomQuery(
    `
    _id
  `,
    {
      variables: {
        filter: {
          users: [
            {
              id: contextUser._id,
              from: contextCompany._id,
            },
            {
              from: toCompanyID,
            },
          ],
          exactlyMatch: true,
          companyId: contextCompany._id,
          userId: contextUser._id,
        },
        limit: 1,
      },
    }
  );
  if (loading) return <CircularProgress center color="primary" />;
  const chatroom = data ? data.chatrooms.items[0] : null;

  return (
    <Paper className={classes.paper}>
      <Grid
        container
        justifyContent="center"
        spacing={1}
        className={classes.rootContainer}
      >
        <Dialog
          className="modal-blank modal-fullheight"
          open={isShowMessenger}
          onClose={() => setIsShowMessenger(false)}
          fullWidth
          maxWidth="xs"
        >
          <Chatroom
            isModal
            defaultMessage={t(
              'hi_i_am_interested_in_dropshipping_you_products_would_you_be_willing_to_enable_your_dropshipping_features'
            )}
            onSendSuccessful={() => {
              notification.success(t('successful_sending'));
              setIsShowMessenger(false);
              history.push(path('product.dropshipped.request', { companyID }));
            }}
            defaultMessageTags={[MESSAGE.TAG.DROPSHIPPING]}
            onClose={() => setIsShowMessenger(false)}
            chatroomId={chatroom ? chatroom._id : undefined}
            receiver={{
              companyId: toCompanyID,
            }}
          />
        </Dialog>
        <Grid container item xs={12} justifyContent="center">
          <Typography variant="h6">
            {t(
              'this_company_has_not_enabled_dropshipping_submit_a_suggestion_to_this_company'
            )}
          </Typography>
        </Grid>
        <Grid container item xs={12} justifyContent="center">
          <Button
            variant="contained"
            color="primary"
            startIcon={<SendIcon />}
            onClick={() => setIsShowMessenger(true)}
          >
            {t('send_message')}
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
}
